module.exports = __webpack_public_path__ + "media/images/flags/16/European-Union-b11a3152af6653b150698c89e4830046.png";